import { Alert, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const AddedToCartMessageComponent = ({ showCartMessage, setShowCartMessage }) => {
  const navigate = useNavigate();
    const goBack = () => {
        navigate(-1);
    }

  return (
    <Alert
      show={showCartMessage}
      variant="success"
      onClose={() => setShowCartMessage(false)}
      dismissible
    >
      <Alert.Heading>Il prodotto è stato aggiunto al carrello</Alert.Heading>
      <p>
        <Button variant="secondary" onClick={goBack}>Acquisti</Button>{" "}
        <Link to="/cart">
          <Button variant="success">Vai al carrello</Button>
        </Link>
      </p>
    </Alert>
  );
};

export default AddedToCartMessageComponent;
